import styled from '@emotion/styled';
import {
  mixinFlexboxColumn,
  mixinFlexCenter,
  mixinOverflow,
  mixinParagraphHeading,
} from 'webapp-lib/styling';

export const StyledPreviewDialog = styled.div`
  cursor: default;
  ${mixinFlexboxColumn}
  min-height: 0;

  .PdfViewer {
    min-height: 0;
    margin: 0;
    ${mixinOverflow}
  }
`;

export const PreviewActionRow = styled.div`
  display: flex;
  margin-bottom: var(--gutter-little);
`;

export const ErrorView = styled.div`
  height: 60vh;
  width: max(40vw, 400px);
  margin-left: var(--gutter-big);
  margin-right: var(--gutter-big);
  text-align: center;
  ${mixinFlexCenter}
  flex-direction: column;
  font-weight: var(--font-weight-content);

  .title {
    ${mixinParagraphHeading}
    margin-bottom: var(--gutter-small);
  }
`;
